import { contains, isOrder }     from '../../domain/sfp/chapter-domain';
import { ChartData }             from "react-chartjs-2";
import Result                    from '../../model/result';
import { ColorsHelper }          from "../../util/colors";
import _                         from 'lodash';
import LocalAuthority            from '../../model/local-authority';
import Observation               from '../../model/observation';

const COLOR_GREEN_CHART          = "#62D762"
const COLOR_RED_CHART            = "#CC534F"
const COLOR_1_CHART_TDB           = "#50B1BE"
const COLOR_2_CHART_TDB           = "#E09E00"

const _setChartData = (props, context, fromTdb = false) => {
    const localAuthority = props.currentLocalAuthority || props.localAuthority;
    if (!localAuthority) return;

    let dataFonctReceipts          = _getDataFonct(true, true, localAuthority, context.years);
    let dataFonctExpense           = _getDataFonct(true, false, localAuthority, context.years);
    let dataFonctReceiptsArranged  = _getDataFonctArranged(true, true, dataFonctReceipts, localAuthority.observations, localAuthority.accounts, context.years);
    let dataFonctExpenseArranged   = _getDataFonctArranged(true, false, dataFonctExpense, localAuthority.observations, localAuthority.accounts, context.years);

    let dataInvestReceipts         = _getDataInvest(false, true, localAuthority, context.years);
    let dataInvestExpense          = _getDataInvest(false, false, localAuthority, context.years);
    let dataInvestReceiptsArranged = _getDataInvestArranged(false, true, context.years, dataInvestReceipts, localAuthority.observations, localAuthority.accounts, context.years);
    let dataInvestExpenseArranged  = _getDataInvestArranged(false, false, context.years, dataInvestExpense, localAuthority.observations, localAuthority.accounts, context.years);

    let tableResData               = _getTotalGeneralData(dataFonctReceiptsArranged, dataFonctExpenseArranged, dataInvestReceiptsArranged, dataInvestExpenseArranged, localAuthority, context);
    let tableResYears              = _getRes(tableResData, localAuthority, context.years, context)
    let tableCafBData              = _getTableCafBData(localAuthority.observations, localAuthority.accounts, context.years, tableResYears);
    let tableCafNData              = _getTableCafNData(tableCafBData, localAuthority.observations, localAuthority.accounts, context.years);
    const chartData                = _getChartData(dataFonctReceiptsArranged, dataFonctExpenseArranged, tableCafBData, tableCafNData, context.years, fromTdb);    

    context.setState(
    {
        chartData,
        dataFonctReceipts,
        dataFonctReceiptsArranged,
        dataFonctExpense,
        dataFonctExpenseArranged,
        dataInvestReceipts,
        dataInvestReceiptsArranged,
        dataInvestExpense,
        dataInvestExpenseArranged,
        loading: false,
        tableResData,
        tableResYears,
        tableCafBData,
        tableCafNData
    },
    () => {
        // console.log("State after update: ", context.state);
    });    
}


const _getDataFonct = (
    /** @type {Boolean} */        operation,
    /** @type {Boolean} */        receipts,
    /** @type {LocalAuthority} */ localAuthority,
    /** @type {Number[]} */       years
) => {

let listChapter = [];
let filteredArranged = [];
if (localAuthority) {

    // On récupère tout les accounts de la localAuthority en fonction de l'operation et du receipts
        filteredArranged = localAuthority.accounts
            .filter(laca => (
                laca.account.operation === operation
                && (
                    laca.account.receipts === receipts
                    || laca.account.expense !== receipts
                )
            ));
    // On ajoute chaque chapitre qu'une seule fois à une liste -> listChapter
        filteredArranged.forEach(fa => {
            // Si la liste contient déjà le chapitre du laca, itération suivante
            if (contains(listChapter, fa.chapter)) return
            // Si le chapitre du laca n'est pas défini, ajoute `null` à la liste
            if (!fa.chapter) listChapter.push(null)
            // Sinon s'il n'est pas d'ordre, ajoute le chapitre à la liste
            else if (!isOrder(fa.chapter)) listChapter.push(fa.chapter)
        });

        listChapter = _.sortBy(listChapter, ['id']);
        const data = listChapter.map(chapter => {
                const row = { chapter };
                // Pour chaque année on filtre les nouvelles observations par rapport à y, receipts, operation
                years.forEach(y => {
                    const observations = _.filter(localAuthority.observations, (/** @type {Observation}*/ o) => {
                        const obsIndexedAccount = _.find(filteredArranged, c => o.account.id === c.account.id);
                        const isSameYear = o.year === y;
                        const isSameReceipts = o.receipts === receipts;
                        const isSameOperation = o.account.operation === operation;
                        if(chapter === null) return isSameYear && isSameReceipts && isSameOperation && obsIndexedAccount && null === obsIndexedAccount.chapter;
                        return obsIndexedAccount && obsIndexedAccount.chapter && obsIndexedAccount.chapter.id === chapter.id  && isSameYear && isSameReceipts && isSameOperation;
                    })
                    row[y] = _.round(_.sumBy(observations, o => o.amount), 2);
                })
                row.isCurrency                 = true
                if(chapter) row.label          = chapter.label
                if(null === chapter) row.label = "Non chapitrés"
                return row
            });
        return data;
    }
}


const _getDataFonctArranged = (
    /** @type {Boolean} */        operation,
    /** @type {Boolean} */        receipts,
    /** @type {Object[]} */       dataFonct,
    /** @type {Observation[]} */  observations,
    /** @type {Account[]} */      accounts,
    /** @type {Number[]} */       years
) => {

    let realOperationTab = [];
    let obj = {};

    if(true === operation && true === receipts) {
        let orderOperationReceipt = _getOrderOperation(accounts, observations, true, true, years)
        let resultatGlobal        = {label: 'Total recette fonctionnement', isCurrency: true, isTitle: true}
        let title                 = {label: 'Recettes de fonctionnement', isTitle : true}
        let totalOpeOrdre         = orderOperationReceipt.find(op => 'orderoperation' === op.id)

        years.forEach(y => {
            obj[y.toString()] = _.round(_.sumBy(dataFonct, row => {
                return row[y.toString()];
            }), 2)
        })
        obj.label      = "Recettes réelles de fonctionnement";
        obj.id         = "receipts"
        obj.isTitle    = true
        obj.isCurrency = true
        realOperationTab.push(obj)

        years.forEach(y => {
            resultatGlobal[y.toString()] = obj[y.toString()] + totalOpeOrdre[y.toString()]
        })

        let data = _.concat([], [title], dataFonct, realOperationTab, orderOperationReceipt, [resultatGlobal]);
        return data;
    }

    if(true === operation && false === receipts) {
        let orderOperationExpense = _getOrderOperation(accounts, observations, true, false, years)
        let resultatGlobal        = {label: 'Total dépense fonctionnement', isCurrency: true, isTitle: true}
        let title                 = {label: 'Dépenses de fonctionnement', isTitle : true}
        let totalOpeOrdre         = orderOperationExpense.find(op => 'orderoperation' === op.id)

        years.forEach(y => {
            obj[y.toString()] = _.round(_.sumBy(dataFonct, row => {
                return row[y.toString()];
            }), 2)
        })
        obj.id         = "expense"
        obj.isCurrency = true
        obj.isTitle    = true
        obj.label      = "Dépenses réelles de fonctionnement";
        realOperationTab.push(obj)

        years.forEach(y => {
            resultatGlobal[y.toString()] = obj[y.toString()] + totalOpeOrdre[y.toString()]
        })

        let data = _.concat([], [title], dataFonct, realOperationTab, orderOperationExpense, [resultatGlobal]);
        return data;
    }
}


const _getDataInvest = (
    /** @type {Boolean} */        operation,
    /** @type {Boolean} */        receipts,
    /** @type {LocalAuthority} */ localAuthority,
    /** @type {Number[]} */       years
) => {

    let listChapter      = [];
    let filteredArranged = [];
    if (localAuthority) {

        // On récupère tout les accounts de la localAuthority en fonction de
        // l'operation et du receipts
        filteredArranged = localAuthority.accounts
            .filter(laca => (
                laca.account.operation === operation
                && (
                    laca.account.receipts === receipts
                    || laca.account.expense !== receipts
                )
            ));
        filteredArranged.forEach(fa => {
            // Si la liste contient déjà le chapitre du laca, itération suivante
            if (contains(listChapter, fa.chapter)) return
            // Si le chapitre du laca n'est pas défini, ajoute `null` à la liste
            if (!fa.chapter) listChapter.push(null)
            // Sinon s'il n'est pas d'ordre, ajoute le chapitre à la liste
            else if (!isOrder(fa.chapter)) listChapter.push(fa.chapter)
        });

        // On ajoute le chapitre de depense ou de recette en fonction de receipts (si vrai ou faux)
        listChapter = _.sortBy(listChapter, ['id']);
        const data = listChapter.map(chapter => {
            const row = { chapter };
            // Pour chaque année on filtre les nouvelles observations par rapport à y, receipts, operation
            years.forEach(y => {
                const observations = _.filter(localAuthority.observations, (/** @type {Observation}*/ o) => {
                    const obsIndexedAccount = _.find(filteredArranged, c => o.account.id === c.account.id);
                    const isSameYear = o.year === y;
                    const isSameReceipts = o.receipts === receipts;
                    const isSameOperation = o.account.operation === operation;
                    if(chapter === null) return isSameYear && isSameReceipts && isSameOperation && obsIndexedAccount && null === obsIndexedAccount.chapter;
                    return obsIndexedAccount && obsIndexedAccount.chapter && obsIndexedAccount.chapter.id === chapter.id  && isSameYear && isSameReceipts
                        && isSameOperation;
                })
                row[y] = _.round(_.sumBy(observations, o => o.amount), 2);
            })
            row.isCurrency                 = true
            if(chapter) row.label          = chapter.label
            if(null === chapter) row.label = "Non chapitrés"
            return row;
        });
    return data;
    }
}

const _getDataInvestArranged = (
    /** @type {Boolean} */        operation,
    /** @type {Boolean} */        receipts,
    /** @type {Number[]} */       years,
    /** @type {Object[]} */       dataInvest,
    /** @type {Observation[]} */  observations,
    /** @type {Account[]} */      accounts
 ) => {

    if(false === operation && true === receipts) {
        let accountsReceiptsEquipment = [];
        let accountsReceiptsFinancial = [];
        let listOperationOrderReceipt = _getOrderOperation(accounts, observations, false, true, years);
        let noneChapter               = [];
        let obj                       = {};
        let receiptsEquipment         = [];
        let receiptsFinancial         = [];
        let resultatGlobal            = {label: 'Total recette investissement', isCurrency: true, isTitle: true}
        let title                     = {label: 'Recettes d\'investissement', isTitle : true}
        let totalOpeOrdre             = listOperationOrderReceipt.find(op => 'orderoperation' === op.id)

        // Ajout des comptes recettes d'équipement
        // Ajout des comptes recettes financières
        // Ajout des comptes non chapitrés dans le tableau noneChapter
        years.forEach(y => {
            dataInvest.forEach(row => {
                if(row[y.toString()]) {
                    if(row.chapter && _.some(row.chapter.types, type => type.operationType.id === "EQUIPMENT" && type.receipts) && !_.find(accountsReceiptsEquipment, acc => acc.chapter === row.chapter)) accountsReceiptsEquipment.push(row)
                    if(row.chapter && _.some(row.chapter.types, type => type.operationType.id === "FINANCIAL" && type.receipts) && !_.find(accountsReceiptsFinancial, acc => acc.chapter === row.chapter)) accountsReceiptsFinancial.push(row)
                    if(null === row.chapter && !_.find(noneChapter, acc => acc.chapter === row.chapter)) { row.label = "Non chapitrés" ; noneChapter.push(row)}
                }
            })
        })


        // Calcul des recettes d'équipement
        years.forEach(y => {
            obj[y.toString()] = _.round(_.sumBy(accountsReceiptsEquipment, row => {
                return row[y.toString()]
            }), 2)
        })
        obj.isTitle    = true
        obj.isCurrency = true
        obj.label      = "Recettes d'équipement";
        obj.id         = "receiptsEquipment"
        receiptsEquipment.push(obj);
        obj            = {};

        // Calcul des recettes financières
        years.forEach(y => {
            obj[y.toString()] = _.round(_.sumBy(accountsReceiptsFinancial, row => {
                return row[y.toString()];
            }), 2)
        })
        obj.isTitle    = true
        obj.isCurrency = true
        obj.label      = "Recettes financières"
        obj.id         = "receiptsFinancial"
        receiptsFinancial.push(obj)
        obj            = {};

        years.forEach(y => {
            resultatGlobal[y.toString()] = receiptsFinancial[0][y.toString()] + receiptsEquipment[0][y.toString()] + totalOpeOrdre[y.toString()]
        })
        let data = _.concat([], [title], accountsReceiptsEquipment, receiptsEquipment, accountsReceiptsFinancial, noneChapter, receiptsFinancial, listOperationOrderReceipt, [resultatGlobal]);
        return data;
    }

    if(false === operation && false === receipts) {
        let accountsExpenseEquipment  = [];
        let accountsExpenseFinancial  = [];
        let expenseEquipment          = [];
        let expenseFinancial          = [];
        let listOperationOrderExpense = _getOrderOperation(accounts, observations, false, false, years);
        let noneChapter               = [];
        let obj                       = {};
        let resultatGlobal            = {label: 'Total dépense investissement', isCurrency: true, isTitle: true}
        let title                     = {label: 'Dépenses d\'investissement', isTitle : true}
        let totalOpeOrdre             = listOperationOrderExpense.find(op => 'orderoperation' === op.id)

        // Ajout des chapitres dans leurs tableaux respectifs
        years.forEach(y => {
           dataInvest.forEach(row => {
                if(row[y.toString()]) {
                    if(row.chapter && _.some(row.chapter.types, type => type.operationType.id === "EQUIPMENT" && type.expense) && !_.find(accountsExpenseEquipment, acc => acc.chapter === row.chapter)) accountsExpenseEquipment.push(row);
                    if(row.chapter && _.some(row.chapter.types, type => type.operationType.id === "FINANCIAL" && type.expense) && !_.find(accountsExpenseFinancial, acc => acc.chapter === row.chapter)) accountsExpenseFinancial.push(row);
                    if(null === row.chapter && !_.find(noneChapter, acc => acc.chapter === row.chapter)) { row.label = "Non chapitrés"; noneChapter.push(row) }
                }
            })
        })

        // Calcul des operations de depenses d'équipements
        years.forEach(y => {
            obj[y.toString()] = _.round(_.sumBy(accountsExpenseEquipment, row => {
                return row[y.toString()]
            }), 2)
        })
        obj.isCurrency = true
        obj.isTitle    = true
        obj.id         = "expenseEquipment"
        obj.label      = "Dépenses d'équipement";
        expenseEquipment.push(obj);
        obj            = {};

        // Calcul des operations de dépense financières
        years.forEach(y => {
            obj[y.toString()] = _.round(_.sumBy(accountsExpenseFinancial, row => {
                return row[y.toString()];
            }), 2)
        })
        obj.isCurrency = true
        obj.isTitle    = true
        obj.id         = "expenseFinancial"
        obj.label      = "Dépenses financières"
        expenseFinancial.push(obj)
        obj            = {};

        years.forEach(y => {
            resultatGlobal[y.toString()] = expenseEquipment[0][y.toString()] + expenseFinancial[0][y.toString()] + totalOpeOrdre[y.toString()]
        })
        let data = _.concat([], [title], accountsExpenseEquipment, expenseEquipment, accountsExpenseFinancial, noneChapter, expenseFinancial, listOperationOrderExpense, [resultatGlobal]);
        return data;
    }
}


const _getOrderOperation = (
    /** @type {Account[]} */     accounts,
    /** @type {Observation[]} */ observations,
    /** @type {Boolean} */       operation,
    /** @type {Boolean} */       receipts,
    /** @type {Number[]} */      years
) => {
    let listChapter = [];
    let orderOperationTotal = {id: 'orderoperation', label: 'Opération d\'ordre'};

    // On filtre les accounts afin d'avoir uniquement les comptes d'opération d'ordre
    let filteredArranged = accounts
        .filter(laca => (
            laca.account
            && laca.account.operation === operation
            && (laca.account.receipts === receipts || laca.account.expense !== receipts)
            && laca.chapter
            && _.some(laca.chapter.types, type => type && type.operationType.id === "ORDER")
            && laca.chapter.number.startsWith("0")
        ));

    // Initialisation de l'objet orderOperationTotal afin de +=
    _initializeValues(orderOperationTotal, years)

    // On ajoute chaque chapitre qu'une seule fois à une liste -> listChapter
    filteredArranged.forEach(fa => {
        if(!_.some(listChapter, ch => ch.chapter.number === fa.chapter.number)) {
            listChapter.push({chapter: fa.chapter, account: fa.account, label: fa.chapter.label});
        }
    })

    // On map les lignes de data avec les infos des lignes de listChapter
    const data = listChapter.map(info => {
        const row = { info };
        // Pour chaque année on filtre les nouvelles observations par rapport à y, receipts, operation
        years.forEach(y => {
            const obs = _.filter(observations, (/** @type {Observation}*/ o) => {
                const obsIndexedAccount = _.find(filteredArranged, c => o.account.id === c.account.id);
                const isSameYear      = o.year === y;
                const isSameReceipts  = o.receipts === receipts;
                const isSameOperation = o.account.operation === operation;
                return obsIndexedAccount && obsIndexedAccount.chapter && obsIndexedAccount.chapter.id === info.chapter.id  && isSameYear && isSameReceipts && isSameOperation;
            })
            row[y] = _.round(_.sumBy(obs, o => o.amount), 2);
            orderOperationTotal[y.toString()] += row[y.toString()]
        })
        row.isCurrency = true
        row.label      = info.chapter.label
        return row
    });
    orderOperationTotal.isCurrency = true
    orderOperationTotal.isTitle    = true
    data.push(orderOperationTotal)
    return data;
}

const _initializeValues = (data, years) => {
    years.forEach(y => {
        data[y.toString()] = 0
    })
}


const _getTotalGeneralData = (dataFonctReceiptsArranged, dataFonctExpenseArranged, dataInvestReceiptsArranged, dataInvestExpenseArranged, currentLocalAuthority, context) =>
{
    let results       = currentLocalAuthority.results;
    let years         = context.years;
    let sectionFonct  = _getTableResData(dataFonctReceiptsArranged, dataFonctExpenseArranged, years, true, results);
    let sectionInvest = _getTableResData(dataInvestReceiptsArranged, dataInvestExpenseArranged, years, false, results);

    return [
        {
            label            : 'Section fonctionnement',
            ...sectionFonct,
            isCurrency       : true,
        },
        {
            label            : 'Section investissement',
            ...sectionInvest,
            isCurrency       : true,
        },
        {
            label            : 'Résultat global',
            ..._getResultatGlobal(sectionFonct, sectionInvest, years),
            isCurrency       : true,
            isTitle          : true
        }
    ]
}

const _getTableResData = (
    /** @type {Object[]} */ dataReceipts,
    /** @type {Object[]} */ dataExpense,
    /** @type {Number[]} */ years,
    /** @type {Boolean}  */ operation,
    /** @type {Result[]} */ results,
) => {
        let obj = {};
        years.forEach(y => {
            obj[y.toString()] =
            _.sumBy(dataReceipts, row => {
                if (row.id && (row.id === "receipts" || row.id === "orderoperation" || row.id === "receiptsFinancial"|| row.id === "receiptsEquipment"))
                        return row[y.toString()]
            })
            -
            _.sumBy(dataExpense, row => {
                if (row.id && (row.id === "expense" || row.id === "orderoperation" || row.id === "expenseEquipment" || row.id === "expenseFinancial"))
                        return row[y.toString()]
            })

            let result = _.find(results, r => { r != undefined && r.year === y-1 && r.operation === operation })
            if(result) {
                obj[y.toString()] = _.add(obj[y.toString()], result.amount)
            }
        })

        return obj;
    }

const _getResultatGlobal = (
    /**@type {Object[]} */ sectionFonct,
    /**@type {Object[]} */ sectionInvest,
    /** @type {Number[]} */ years
) => {
    let obj = {};

    years.forEach(y => {
        obj[y.toString()] = _.subtract(sectionFonct[y.toString()], sectionInvest[y.toString()])
    })
    return obj;
}

const _getRes = (
    /** @type {Object} */ resData,
    /** @type {LocalAuthority} */ localAuthority,
    /** @type {Number[]} */ years,
    context
) => {
    let res            = {title: null};
    let results        = [];
    let resultatGlobal = {label: 'Résultat net', isCurrency: true, isTitle: true}
    let title          = {label: 'Résultat', isTitle: true}

    years.forEach(y => {
            let result = _.find(localAuthority.results, (/** @type {Result} */ r)  => r.year === y-1 && r.operation === true)
            res[y.toString()]     = _.round(resData[0][y.toString()], 2)
            results[y.toString()] = result ? result.amount : 0
        })

    res.title          = "Résultat de l'année"
    res.label          = "Résultat de l'année"
    res.isCurrency     = true

    const loading      = {}

    years.forEach(y => {
        resultatGlobal[y.toString()] = res[y.toString()] + results[y.toString()]
        loading[y.toString()] = false
    })

    return [
        title,
        res,
        {
            title: "Report N-1",
            label: "Report N-1",
            editable: !context.state.consulted,
            isCurrency: true,
            ...results,
            loading
        },
        resultatGlobal
    ];
}


const _getTableCafBData = (
    /** @type {Observation[]} */ observations,
    /** @type {LocalAuthorityChapterAccount} */ accounts,
    /** @type {Number[]} */ years,
    /** @type {Number[]} */ tabResultYears
) => {

    let cafBrute     = {label: "Capacité d'autofinancement brute", id: "cafb", isCurrency: true, isTitle: true}
    let title        = {label: "C.A.F Brute", isCurrency: true, isTitle: true}
    let listAccounts = [title, tabResultYears[1]]

    _.forEach(accounts, (/** @type {LocalAuthorityChapterAcccount} */ laca) => {
        const lacaNum = laca.account.number
        let row = {};
        let obj = {};
        if(_.startsWith(lacaNum, "68"))
        {
            if(!listAccounts.find(r => r.account === "68"))     row = {account: "68", label: laca.account.number + " - " + laca.account.label, addition: true}; obj = {addition: true};
        }
        if (_.isEqual(lacaNum, "675") || _.isEqual(lacaNum, "676"))
        {
            if(!listAccounts.find(r => r.account === lacaNum))  row = {account: laca.account.number, label: laca.account.number + " - " + laca.account.label, addition: true}; obj = {addition: true};
        }
        if(_.startsWith(lacaNum, "78"))
        {
            if(!listAccounts.find(row => row.account === "78")) row = {account: "78", label: laca.account.number + " - " + laca.account.label, addition: false}; obj = {addition: false};
        }
        if (_.isEqual(lacaNum, "775") || _.isEqual(lacaNum, "776")|| _.isEqual(lacaNum, "777"))
            if(!listAccounts.find(r => r.account === lacaNum))  row = {account: laca.account.number, label: laca.account.number + " - " + laca.account.label, addition: false}; obj = {addition: false};

        _.forEach(years, (/** @type {Number} */ y) => {
            if(undefined !== row.account)
            {
                switch(row.account)
                {
                    case "68":
                    {
                        row[y.toString()] = _getAmountByChapterId("68", observations, y)
                        break;
                    }
                    case "78":
                    {
                        row[y.toString()] = _getAmountByChapterId("78", observations, y)
                        break;
                    }
                    default:
                    {
                        row[y.toString()] = _.sumBy(observations, (/** @type {Observation} */ o) =>
                        {
                            if(o.account.number.startsWith(lacaNum) && o.year === y) return o.amount
                            else return 0
                        })
                    }
                }
            }
        })
        row.isCurrency = true
        if(undefined !== row.account) listAccounts.push(row);

        years.forEach(y => {
            const yearKey = y.toString();
            obj[yearKey]  += _.find(observations, (/** @type {Observation} */ o) => {
                const accNum = o.account.number;

                if((accNum === '68' || accNum === '675' || accNum === '676') && o.year === y)
                    return -o.amount;
                else ((accNum === '78' || accNum === '775' || accNum === '776' || accNum === '777') && o.year === y)
                    return o.amount
            })
        })
        obj.isCurrency = true
        if(obj.addition === undefined) listAccounts.push(obj)
    })

    years.forEach(y => {
        cafBrute[y.toString()] = _.sumBy(listAccounts, row => {
            if(row[y.toString()] && row[y.toString()] != undefined)
            {
                if(false === row.addition) return -row[y.toString()]
                else return row[y.toString()]
            } else return 0
        })
    })
    listAccounts.push(cafBrute)
    return listAccounts;
}

const _getTableCafNData = (
    /** @type {Object[]} */ tableCafB,
    /** @type {Observation[]} */ observations,
    /** @type {LocalAuthorityChapterAccount} */ accounts,
    /** @type {Number[]} */ years
) => {
    let indexCafB    = _.findIndex(tableCafB, row => "cafb" === row.id)
    let listAccounts = [];
    let obj          = {};
    // Initialisation de obj[y.toString()] à 0 pour faire la somme de ces comptes
    years.forEach(y => {
        obj[y.toString()] = 0;
    })

    _.forEach(accounts, (/** @type {LocalAuthorityChapterAcccount} */ laca) => {
        let row = {};

        if(_.startsWith(laca.account.number, "164") && !laca.account.operation && laca.account.expense) {
            const lacaNumber = laca.account.number;
            if(!listAccounts.find(r => r.account === lacaNumber)) row = {account: laca.account, label: undefined };

            _.forEach(years, (/** @type {Number} */ y) => {
                row[y.toString()] = _.sumBy(observations, (/** @type {Observation} */ o) => {
                    if(laca.account.number === o.account.number && o.year === y && o.amount != undefined && o.receipts === false) return o.amount;
                    else return 0;
                })
            })
            row.label      = laca.account.number + " - " + laca.account.label
            row.isCurrency = true
            listAccounts.push(row)
        }
    })

    listAccounts.forEach(a => {
        years.forEach(y => {
            obj[y.toString()] += a[y.toString()]
        })
    })

    obj.label      = "Remboursement des emprunts";
    obj.id         = "debt";
    obj.isCurrency = true
    obj.isTitle    = true
    listAccounts.splice(0, 0, obj)
    obj = {}

    if(-1 !== indexCafB) {
        years.forEach(y => {
            obj[y.toString()] = tableCafB[indexCafB][y.toString()] - listAccounts[0][y.toString()]
        })
        obj.label      = "Capacité autofinancement nette ";
        obj.id         = "cafn";
        obj.isCurrency = true
        obj.isTitle    = true
        listAccounts.push(obj)
    }
    return listAccounts;
}


const _getAmountByChapterId = (
    /** @type {String} */ id,
    /** @type {Observation[]} */ observations,
    /** @type {Number} */ y
) => {
    let tabData = _.sumBy(observations, (/** @type {Observation} */ o) => {
            if(o.account.number.startsWith(id) && o.year === y) {
                if(o.account.number.startsWith("7")) return o.amount
                return o.amount
            }
        })
    if (undefined === tabData) tabData = 0
    return tabData;
}


/**
 * @param {object[]} tableCaf
 * @param {number[]} years
 *
 * @returns {ChartData}
 */
const _getChartData = (
    /** @type {Object[]} */ dataFonctReceipt,
    /** @type {Object[]} */ dataFonctExpense,
    /** @type {Object[]} */ dataCafB,
    /** @type {Object[]} */ dataCafN,
    /** @type {Number[]} */ years,
    /** @type {boolean} */ fromTdb
) => {

    /** @type {ChartData} */ const data = {}
    data.labels = years.map(year => year.toString())

    if (!dataFonctReceipt || !dataFonctReceipt.length || !dataFonctExpense || !dataFonctExpense.length ||
            !dataCafB || !dataCafB.length || !dataCafN || !dataCafN.length) return data

    let cafBrute = [];
    let cafNette = [];

    const colors       = ColorsHelper.getEquidistantPastelColors(5, 30)
    const objCafB      = dataCafB.find(row => row.id === "cafb")
    const objCafN      = dataCafN.find(row => row.id === "cafn")
    const realReceipts = dataFonctReceipt.find(row => { if(row.id === "receipts") return row })
    const realExpense  = dataFonctExpense.find(row => { if(row.id === "expense")  return row })
    const sumDebt      = dataCafN.find(row => { if(row.id === "debt") return row})
    cafNette.push(objCafN);
    cafBrute.push(objCafB);

    data.datasets = [
        {
            borderColor: fromTdb ? COLOR_1_CHART_TDB : COLOR_GREEN_CHART,
            data       : data.labels.map(label => realReceipts[label]),
            fill       : false,
            label      : "Recettes réelles",
            pointRadius: fromTdb ? 0 : 3,
        },
        {
            borderColor: fromTdb ? COLOR_2_CHART_TDB : COLOR_RED_CHART,
            data       : data.labels.map(label => realExpense[label]),
            fill       : false,
            label      : "Dépenses réelles",
            pointRadius: fromTdb ? 0 : 3,
        },
        {
            borderColor: fromTdb ? COLOR_1_CHART_TDB : colors[2],
            data       : data.labels.map(label => cafBrute[0][label]),
            fill       : false,
            label      : "CAF brute",
            pointRadius: fromTdb ? 0 : 3,
        },
        {
            borderColor: fromTdb ? COLOR_2_CHART_TDB : colors[3],
            data       : data.labels.map(label => sumDebt[label]),
            fill       : false,
            label      : "Remboursement des emprunts",
            pointRadius: fromTdb ? 0 : 3,
        },
        {
            borderColor: colors[4],
            data       : data.labels.map(label => cafNette[0][label]),
            fill       : false,
            label      : "CAF nette",
            pointRadius: fromTdb ? 0 : 3,
        }
    ]
    return data
}

/**
 * Lignes « Total recette investissement » / « Total dépense investissement »
 * calculées comme dans le Récapitulatif (onglet Investissement).
 */
export const getInvestTotals = (localAuthority, years) => {
    const receipts = _getDataInvestArranged(false, true, years, _getDataInvest(false, true, localAuthority, years), localAuthority.observations, localAuthority.accounts)
    const expense  = _getDataInvestArranged(false, false, years, _getDataInvest(false, false, localAuthority, years), localAuthority.observations, localAuthority.accounts)
    return {
        receipts: receipts[receipts.length - 1],
        expense:  expense[expense.length - 1]
    }
}

export default _setChartData;


// WEBPACK FOOTER //
// ./src/component/utils/utilChartData.js